import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function CopyIcon() {
    return (
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true">
            <rect x="9" y="9" width="11" height="11" rx="2" />
            <path d="M5 15V6a2 2 0 0 1 2-2h9" />
        </svg>
    );
}

function CheckIcon() {
    return (
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M5 12l4.5 4.5L19 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

/**
 * Copy-to-clipboard affordance for sub/sid — "shown because support asks for them".
 * EAA-1820: pulled out of `ProfilePage.tsx` (unchanged) so the "Định danh đăng
 * nhập" card on the Thông tin tab (frame 77) can reuse it alongside the
 * "Quyền của tôi" tab's own claim rows, without a circular import between the
 * two tab components.
 */
export function CopyableValue({ value, ariaLabel }: { value: string; ariaLabel: string }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    async function handleCopy() {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
        } catch {
            /* Clipboard API unavailable — the value is still select-all-able by hand. */
        }
    }

    return (
        <span className="portal-profile-claim-value-row">
            <code className="portal-profile-claim-value">{value}</code>
            <button
                type="button"
                className={'portal-profile-claim-copy' + (copied ? ' is-copied' : '')}
                onClick={() => void handleCopy()}
                aria-label={t('profile.copyAriaLabel', { label: ariaLabel })}
                title={copied ? t('profile.copied') : t('profile.copy')}
            >
                {copied ? <CheckIcon /> : <CopyIcon />}
            </button>
        </span>
    );
}

export default CopyableValue;
